import { render, staticRenderFns } from "./SaveThePlanet.vue?vue&type=template&id=1c306d3a&scoped=true&"
import script from "./SaveThePlanet.vue?vue&type=script&lang=js&"
export * from "./SaveThePlanet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c306d3a",
  null
  
)

export default component.exports